import * as React from 'react';
import { useLocation } from 'react-router';

export const ScrollToTop: React.SFC = () => {
    const { pathname } = useLocation();

    React.useEffect(
        () => {
            window.scrollTo(0, 0);
        },
        [pathname]
    );

    return null;
};
